import { render, staticRenderFns } from "./EmailConfigCreate.vue?vue&type=template&id=258a118d&"
import script from "./EmailConfigCreate.vue?vue&type=script&lang=js&"
export * from "./EmailConfigCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports